import _Object$freeze from "@babel/runtime-corejs2/core-js/object/freeze";
export default _Object$freeze({
  live: '102900000',
  alumni: '102900001',
  testing: '102900002',
  outOfBusiness: '102900003'
});